// QR Menü masa siparişleri ekranı kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'sales.qrOrders';

export const qrOrdersGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Masa Siparişleri nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Müşterilerin masadaki QR menüden verdiği siparişler bu ekrana düşer. Siparişi hazırlayıp teslim ederken durumunu buradan değiştirirsiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık ve düğmeler'),
    stats: t(`${G}.regions.stats`, 'Özet kartları'),
    filters: t(`${G}.regions.filters`, 'Filtreler'),
    table: t(`${G}.regions.table`, 'Sipariş listesi'),
    pagination: t(`${G}.regions.pagination`, 'Sayfalama'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Yeni siparişler kendiliğinden gelir'),
      text: t(`${G}.s1.text`, 'Başlığın yanındaki nokta bağlantıyı gösterir: yeşil "Canlı" ise yeni siparişler sayfayı yenilemeden listenin en üstüne eklenir. Sarı "Bağlanıyor..." veya kırmızı "Bağlantı Yok" görürseniz "Yenile" düğmesine basın.'),
      tips: [
        t(`${G}.s1.tip1`, '"Özet Göster / Özet Gizle" üstteki kartları açıp kapatır.'),
        t(`${G}.s1.tip2`, '"Gün Sonu" düğmesi yalnız bir şube seçiliyken açılır (Şube Filtresi "Tüm Şubeler" ise kapalıdır).'),
      ],
    },
    {
      region: 'stats',
      title: t(`${G}.s2.title`, '2. Özet kartlarını okuyun'),
      text: t(`${G}.s2.text`, 'Toplam Sipariş ve Toplam Ciro, o an filtrelenmiş listedeki siparişleri sayar. Bekleyen Siparişler yalnız "Beklemede" durumundakileri gösterir.'),
      tips: [
        t(`${G}.s2.tip1`, 'Gün Sonu Rakamı: seçili şubenin son gün sonu kapanışından sonra gelen tüm siparişlerinin toplamıdır; sipariş durumu fark etmez. Şube seçilmezse 0 görünür.'),
      ],
    },
    {
      region: 'filters',
      title: t(`${G}.s3.title`, '3. Siparişi bulun'),
      text: t(`${G}.s3.text`, 'Arama kutusuna sipariş ID, müşteri adı, menü veya masa adı yazın. Başlangıç / Bitiş Tarihi, Durum Filtresi ve Şube Filtresi ile listeyi daraltın. "Bugün", "Bu Hafta", "Bu Ay" hızlı tarih seçer; "Tarihi Temizle" tarihleri kaldırır.'),
      tips: [
        t(`${G}.s3.tip1`, 'Şube müdürü olarak girdiyseniz Şube Filtresi kendi şubenize ayarlanır.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Durumu ilerletin: Hazır → Teslim Edildi'),
      text: t(`${G}.s4.text`, 'Yeni sipariş "Beklemede" gelir. Hazırlandığında yeşil "Hazır Olarak İşaretle" düğmesine, masaya götürüldüğünde mavi "Teslim Edildi Olarak İşaretle" düğmesine basın. Satıra tıklayınca Sipariş Detayları açılır: ürünler, adet, birim fiyat ve Genel Toplam.'),
      tips: [
        t(`${G}.s4.tip1`, 'Hazır düğmesi yalnız Beklemede / Hazırlanıyor siparişlerde, Teslim düğmesi yalnız Hazır siparişlerde görünür.'),
        t(`${G}.s4.tip2`, 'Durum değişikliği yalnız siparişin durumunu günceller; stok veya kasa kaydı oluşturmaz.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s5.title`, '5. Siparişi iptal edin'),
      text: t(`${G}.s5.text`, 'İptal sütunundaki kırmızı düğme onay penceresi açar; "Siparişi İptal Et" ile onaylayın. İptal geri alınamaz; müşteriyi ayrıca bilgilendirin.'),
      tips: [
        t(`${G}.s5.tip1`, 'İptal edilen sipariş listede "İptal" olarak kalır ve Gün Sonu Rakamı hesabında yine görünür.'),
      ],
    },
    {
      region: 'pagination',
      title: t(`${G}.s6.title`, '6. Sayfalar arasında gezin'),
      text: t(`${G}.s6.text`, 'Liste en yeni sipariş üstte olacak şekilde sıralanır. Alttan sayfa başına satır sayısını seçip sayfalar arasında geçin.'),
    },
  ],
});
